import { z } from 'zod';

export const WahaWhatsAppWebhookResponseSchema = z.object({
  accepted: z.boolean(),
});

export type WahaWhatsAppWebhookResponse = z.infer<typeof WahaWhatsAppWebhookResponseSchema>;
